import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import Antd from 'ant-design-vue'
import mixins from '@/mixins'
import 'ant-design-vue/dist/antd.css'


const app = createApp(App)

app.use(router).use(store).use(Antd).mixin(mixins).mount('#app')